import { jumpHeight, RUN_DURATION } from './frisbee-engine'

export const VICTORY_DURATION = 4200
export const REDUCED_VICTORY_DURATION = 1800
const clamp = (value: number) => Math.max(0, Math.min(1, value))
const smooth = (value: number) => {
  const t = clamp(value)
  return t * t * (3 - 2 * t)
}

/** A presentation-only clock: the run and reward trace stop at exactly ten minutes. */
export function victoryPose(at: number, reduced = false) {
  const caught = reduced || at >= 400
  const gone = at >= (reduced ? 1100 : 2400)
  const height = reduced ? 0 : jumpHeight(at, 0)
  const x = reduced ? 130 : 130 + 70 * smooth(at / 800) + 550 * smooth((at - 800) / 1600)
  return {
    x,
    height,
    caught,
    gone,
    opacity: reduced ? 1 - clamp((at - 800) / 300) : 1,
    petAt: reduced ? 0 : RUN_DURATION + at,
    jumpAt: RUN_DURATION,
    discX: 260 + (227 - 260) * smooth(at / 400),
    discY: 130 + (118 - 130) * smooth(at / 400),
  }
}
